module.exports = __webpack_public_path__ + "img/how-to-customize.f0555261.svg";